import { AchievementByIdQuery } from '../../../../schema';
import { useBackRoute } from '../../../../hooks';
import { Backdrop, Fade, Modal } from '@material-ui/core';
import React from 'react';
import { useStyles } from '../useStyles';
import { AwardPublishModalForm } from './AwardPublishModalForm';

interface AwardPublishModalProps {
  achievement: AchievementByIdQuery | undefined;
}

export const AwardPublishModal = ({ achievement }: AwardPublishModalProps) => {
  const styles = useStyles();
  const { onCancel } = useBackRoute();

  return (
    <Modal
      open={true}
      onClose={onCancel}
      aria-labelledby="Публикация награды"
      aria-describedby="Используйте эту форму для публикации награды"
      className={styles.modal}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={true}>
        <AwardPublishModalForm achievement={achievement} onClose={onCancel} />
      </Fade>
    </Modal>
  );
};
